import { z } from 'zod';
import { toPatchSchema } from '../primitives/patch.js';
import { currencyInputSchema, currencySchema, idSchema, isinInputSchema, isinSchema, tickerSymbolInputSchema, tickerSymbolSchema, } from '../primitives/branded.js';
import { timestampSchema } from '../primitives/timestamp.js';
/** Asset classes Twelve Data exposes that are relevant for this portfolio. */
export const instrumentTypeSchema = z.enum(['stock', 'etf', 'index', 'fund', 'reit', 'other']);
/** Master data for a tradable security. Symbols are unique across the table. */
export const instrumentSchema = z.object({
    id: idSchema,
    symbol: tickerSymbolSchema,
    /**
     * Weltweit eindeutiger Wertpapierschlüssel.
     *
     * Optional, weil nicht jede Quelle ihn liefert — Yahoo etwa nicht. Wo er
     * vorliegt, ist er dem Ticker vorzuziehen: Ein Ticker bezeichnet je nach Börse
     * verschiedene Papiere, eine ISIN immer dasselbe.
     */
    isin: isinSchema.nullable(),
    /** Deutsche Wertpapierkennnummer, sechsstellig. */
    wkn: z.string().max(6).nullable(),
    name: z.string().min(1).max(160),
    exchange: z.string().max(64).nullable(),
    micCode: z.string().max(16).nullable(),
    currency: currencySchema,
    type: instrumentTypeSchema,
    createdAt: timestampSchema,
    updatedAt: timestampSchema,
});
/**
 * Payload accepted when adding an instrument.
 *
 * Built from the normalising input primitives rather than by picking from
 * `instrumentSchema`: this schema only ever validates incoming data, so the
 * transforms that upper-case symbol and currency belong here.
 */
export const createInstrumentSchema = z.object({
    symbol: tickerSymbolInputSchema,
    isin: isinInputSchema.nullish(),
    wkn: z.string().trim().max(6).nullish(),
    name: z.string().min(1).max(160),
    exchange: z.string().max(64).nullish(),
    micCode: z.string().max(16).nullish(),
    currency: currencyInputSchema.default('USD'),
    type: instrumentTypeSchema.default('stock'),
});
/**
 * Jedes Feld außer dem Symbol lässt sich später berichtigen.
 *
 * Ohne Vorgabewerte: Sonst setzte eine Namensänderung nebenbei Währung und Typ
 * zurück.
 */
export const updateInstrumentSchema = toPatchSchema(createInstrumentSchema.omit({ symbol: true }));
/** A search hit from the provider's symbol lookup, not yet persisted. */
export const instrumentSearchResultSchema = z.object({
    symbol: z.string(),
    name: z.string(),
    exchange: z.string().nullable(),
    micCode: z.string().nullable(),
    currency: z.string().nullable(),
    type: z.string().nullable(),
    country: z.string().nullable(),
});
//# sourceMappingURL=instrument.js.map